import * as React from 'react';
import ConfirmDialog from '../ConfirmDialog';
import defaultLocale from '../../locale/default';
import LocaleReceiver from '../../locale-provider/LocaleReceiver';
const HookModal = ({ afterClose, config }, ref) => {
    const [visible, setVisible] = React.useState(true);
    const [innerConfig, setInnerConfig] = React.useState(config);
    function close() {
        setVisible(false);
    }
    React.useImperativeHandle(ref, () => ({
        destroy: close,
        update: (newConfig) => {
            setInnerConfig(originConfig => (Object.assign(Object.assign({}, originConfig), newConfig)));
        },
    }));
    return (<LocaleReceiver componentName="Modal" defaultLocale={defaultLocale.Modal}>
      {(modalLocale) => (<ConfirmDialog {...innerConfig} close={close} visible={visible} afterClose={afterClose} okText={innerConfig.okText ||
        (innerConfig.okCancel ? modalLocale.okText : modalLocale.justOkText)} cancelText={innerConfig.cancelText || modalLocale.cancelText}/>)}
    </LocaleReceiver>);
};
export default React.forwardRef(HookModal);
